


//import * as AWS from 'aws-sdk/global';
const AWS 								= 	require('aws-sdk');
const AmazonCognitoIdentity             =   require('amazon-cognito-identity-js');		/** NOTE: https://www.npmjs.com/package/amazon-cognito-identity-js */
const { postJson }                      =   require('./http');


/**
 * Sensitive informations, remove later!!!!!!!
 */
const IdentityPoolId    =   'us-east-1:56eeea78-35fe-4780-b88c-2741471662e2';
const UserPoolId        =   'us-east-1_H5lBHE6l4';
const ClientId          =   'p7gg9eoscug4tuf2m5d1phqr1';
const AccountStatusUrl  =   'https://oidnlpynvl.execute-api.us-east-1.amazonaws.com/prod/accountstatus';


async function fetchAccountStatus(email) {
	return postJson(AccountStatusUrl, {
		email
	});
}


/**
 * This function will SignOut the currently logged in user from Cognito.
 */
export function cognitoSignout()
{
	var poolData = {
		UserPoolId: 	UserPoolId, 		// Your user pool id here
		ClientId: 		ClientId, 			// Your client id here
	};
	var userPool 		= new AmazonCognitoIdentity.CognitoUserPool(poolData);
	var cognitoUser 	= userPool.getCurrentUser();

	if(cognitoUser)
	{
		cognitoUser.signOut();
	}
}



/**
 * This function will check if any user is curently logged in. This is especially handy between browser refresh.
 */
export function cognitoGetCurrentUser()
{
	var email;

	var poolData = {
		UserPoolId: 	UserPoolId, // Your user pool id here
		ClientId: 		ClientId, // Your client id here
	};
	var userPool 		= new AmazonCognitoIdentity.CognitoUserPool(poolData);
	var cognitoUser 	= userPool.getCurrentUser();
	
	
		return new Promise((resolve, reject) => 
		{
			if (cognitoUser == null) 
			{
				reject({
					status:      "error"
				});
				return;
			}

			cognitoUser.getSession(function(err, session) 
			{
				if (err) {
					reject({
						status:      "error",
						errMessage:  err.message || JSON.stringify(err)
					});
					return;
				}

				if (!session || !session.isValid()) {
					reject({
						status:      "error",
						errMessage:  "User session is invalid"
					});
					return;
				}
			
				// NOTE: getSession must be called to authenticate user before calling getUserAttributes
				cognitoUser.getUserAttributes(function(err, attributes) {
					if (err) {
						reject({
							status:      "error",
							errMessage:  err.message || JSON.stringify(err)
						});
						return;
					}

					const emailAttribute = attributes?.find((attribute) => attribute?.Name === 'email');

					if (!emailAttribute?.Value) {
						reject({
							status:      "error",
							errMessage:  "Missing user email attribute"
						});
						return;
					}

					email = emailAttribute.Value;

					//POTENTIAL: Region needs to be set if not already set previously elsewhere.
					AWS.config.region = 'us-east-1';
				
					AWS.config.credentials = new AWS.CognitoIdentityCredentials({
						IdentityPoolId: IdentityPoolId, 		// your identity pool id here
						Logins: {
							// Change the key below according to the specific region your user pool is in.
							'cognito-idp.us-east-1.amazonaws.com/us-east-1_H5lBHE6l4': session
								.getIdToken()
								.getJwtToken(),
						},
					});

					//refreshes credentials using AWS.CognitoIdentity.getCredentialsForIdentity()
					AWS.config.credentials.refresh(async(error) => {
						if (error) {
							console.error(error);

							reject({
								status:      "error",
								errMessage:  error.message || JSON.stringify(error)
							});
							return;
						}

						try {
							var response = await fetchAccountStatus(email);

							if(Number(response?.statusCode) === 201)
							{
								resolve({
									status:         "success",
									credentials:	AWS.config.credentials,
									email:			email,
									name:			response?.body?.response?.Item?.name || ""
								});
								return;
							}

							reject({
								status:      "error",
								errMessage:  `Unexpected account status response: ${response?.statusCode}`
							});
						}
						catch(fetchError) {
							reject({
								status:      "error",
								errMessage:  fetchError.message || JSON.stringify(fetchError)
							});
						}
					});
				});

			});
		});
}


/**
 * Create new user. This is temporary, as it exposes the AWS related details. We have tried using Lambda, but it's no working. We will get back to it later.
 **/ 
export function cognitoAuthenticateUser(props)
{
    //console.log("authenticate");
    
    var authenticationData = {
    	Username:  props.username,
    	Password:  props.password,
    };
    
    var authenticationDetails = new AmazonCognitoIdentity.AuthenticationDetails(authenticationData);
    
    var poolData = {
	    UserPoolId:     UserPoolId,                                 // Your user pool id here.
	    ClientId:       ClientId                                    // Your client id here.
    };
    
    var userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);
    
    var userData = {
    	Username:   props.username,
    	Pool:       userPool,
    };
    
    var cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);

    return new Promise((resolve, reject) =>
            cognitoUser.authenticateUser(authenticationDetails, {
				// If the provided credentials are correct.
            	onSuccess: function(result) {
             		//POTENTIAL: Region needs to be set if not already set previously elsewhere.
             		AWS.config.region = 'us-east-1';
            
            		AWS.config.credentials = new AWS.CognitoIdentityCredentials({
            			IdentityPoolId: IdentityPoolId,           // Your identity pool id here.
            			Logins: {
            				// Change the key below according to the specific Region your User Pool is in.
            				//'cognito-idp.us-east-1.amazonaws.com/us-east-1_qYdRYNIjq': result
							'cognito-idp.us-east-1.amazonaws.com/us-east-1_H5lBHE6l4': result
							//login : result
            					.getIdToken()
            					.getJwtToken(),
            			},
            		});
            		
            		//Send back the STRINGIFIED AWS.config.credentials to the Frontend, so that in the Frontend we can use it to access AWS services.
            		//console.log(JSON.stringify(AWS.config.credentials));
            		// resolve(
					// 	// response = {
					// 	// 	statusCode:     200,
					// 	// 	body:           JSON.stringify(AWS.config.credentials)
					// 	//}
					// 	//JSON.stringify(AWS.config.credentials)
                         //console.log(JSON.stringify(AWS.config.credentials))
					// );
            
            		//refreshes credentials using AWS.CognitoIdentity.getCredentialsForIdentity()
            		AWS.config.credentials.refresh( async(error) => {
            			if (error) {
            				console.error(error);

							reject({
								// response = {
								// 	statusCode:     400,
								// 	body:           {
								// 		error:	err.message || JSON.stringify(err)
								// 	}
								// }
							status:      "error",
							errMessage:  error.message || JSON.stringify(error),
									
							});
							return;

             			} else {
            				// Instantiate aws sdk service objects now that the credentials have been updated.
            				// example: var s3 = new AWS.S3();
							//var s3 = new AWS.S3();
            				//console.log('Successfully logged!', AWS.config.credentials, s3);
							//resolve(JSON.stringify(AWS.config.credentials));
							//resolve(JSON.stringify(s3));

							// resolve(
							// 	response = {
							// 		statusCode:     200,
							// 		body:           JSON.stringify(AWS.config.credentials)
							// 	}
							//JSON.stringify(AWS.config.credentials)
                            //AWSCredentials  =   AWS.config.credentials;
                            //console.log(AWS.config.credentials)

							try {
								var response = await fetchAccountStatus(props.username);

								if(Number(response?.statusCode) === 201)
								{
									resolve({
										status:         "success",
										credentials:	AWS.config.credentials,
										email:			props.username,
										name:			response?.body?.response?.Item?.name || ""
									});
									return;
								}

								reject({
									status:      "error",
									errMessage:  `Unexpected account status response: ${response?.statusCode}`
								});
							}
							catch(fetchError) {
								reject({
									status:      "error",
									errMessage:  fetchError.message || JSON.stringify(fetchError)
								});
							}
             			}
             		});
            	},
            
				// If the provided credentials are incorrect.
            	onFailure: function(err) {
            		console.log(err);
            		reject({
						// response = {
						// 	statusCode:     400,
						// 	body:           {
						// 		error:	err.message || JSON.stringify(err)
						// 	}
						// }
						status:      "error",
						errMessage:  err.message || JSON.stringify(err),
							
					});
            	},
            })
    );
}

//export default cognitoAuthenticateUser;
